import React, { Component } from 'react';
import { connect } from 'react-redux';
import './projectsidebar.css';
import { projectCategories } from '../../utilities';
import Projectsidebarblock from '../projectsidebarblock/projectsidebarblock';
import { featuredImageWithFallback } from '../../utilities';

class Projectsidebar extends Component {

    constructor(props) {
        super(props);
        this.state = { loading: true };
    }

    componentDidMount() {
        setTimeout(function() {
            this.setState({ loading: false});
        }.bind(this), 500);
    }

    render() {
        return (
            <div className={ this.state.loading ? "projectsidebar projectsidebar--loading" : "projectsidebar"}>
                {
                    this.props.projects.slice(0,6).map((project, index) => {
                        let projectImage = featuredImageWithFallback(project,"medium_large");
                        const projectCategoriesText = projectCategories(project);
                        return ( <Projectsidebarblock key={project.id} id={project.id} slug={project.slug} title={project.title.rendered} projectCategories={projectCategoriesText} image={projectImage}/> )
                    })
                }
            </div>
        );
    }
}

const mapStateToProps = (store) => {
    let projects = [];

    if (store.projects && store.projects.projects) {
        projects = store.projects.projects;
    }

    return {
        projects: projects
    }
}

export default connect(mapStateToProps)(Projectsidebar);



// WEBPACK FOOTER //
// ./src/components/projectsidebar/projectsidebar.js